import React from 'react';
import { LeftKeyContextType, Props } from './types';
import { useReactPath } from 'core/hooks/useReactPath';

// Main Context
export const LeftKeyContext = React.createContext<LeftKeyContextType>(
  {} as LeftKeyContextType,
);

const LeftKeyContextProvider: React.FC<Props> = ({ children }) => {
  
  const path = useReactPath();

  const [key, setkey] = React.useState<string>("dashboard");

  const initialBasePath = path?.split("/")?.[1] || "dashboard";

  React.useEffect(() => {
    if(!!initialBasePath) {
      setkey(key => initialBasePath);
    }
  }, [initialBasePath]);

  return (
    <LeftKeyContext.Provider value={{ key, setkey }}>
      {children}
    </LeftKeyContext.Provider>
  );
};

export default LeftKeyContextProvider;

export const useLeftKey = () => {
  const ctx = React.useContext(LeftKeyContext);
  return ctx.key;
};

export const useSetLeftKey = () => {
  const ctx = React.useContext(LeftKeyContext);
  return ctx.setkey;
};
